/**
 * ファイル操作ユーティリティ
 *
 * ファイル変換、サイズフォーマットなどの共通処理
 */

/**
 * ファイルをBase64文字列に変換
 * dataURL形式ではなく、純粋なBase64データを返す
 */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result;
      if (typeof result === "string") {
        // dataURLからbase64部分のみを抽出
        const base64 = result.split(",")[1];
        resolve(base64);
      } else {
        reject(new Error("Failed to read file"));
      }
    };
    reader.onerror = (error) => reject(error);
  });
}

/**
 * ファイルサイズを人間可読形式にフォーマット
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 B";

  const units = ["B", "KB", "MB", "GB"];
  const k = 1024;
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${units[i]}`;
}
